import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'convention-registration', loadChildren: () => import('app/convention-registration/convention-registration.module').then(m => m.ConventionRegistrationModule) },
  { path: 'conference-registration', loadChildren: () => import('app/conference-registration/conference-registration.module').then(m => m.ConferenceRegistrationModule) },
  { path: 'conference-payment', loadChildren: () => import('app/conference-registration/conference-list/conference-list.module').then(m => m.ConferenceListModule) },
  { path: 'paiement-conference', loadChildren: () => import('app/conference-registration/conference-list/conference-list.module').then(m => m.ConferenceListModule) },
  { path: 'cupe-local-information-form', loadChildren: () => import('app/local-officers/local-officers.module').then(m => m.LocalOfficersModule) },
  { path: 'self-identifications', loadChildren: () => import('app/self-identification/self-identification.module').then(m => m.SelfIdentificationModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
